import { storage } from './storage';
import { useState, useEffect } from 'react';

const defaultSettings = {
	theme: 'light',
	notches: {
		showTags: false,
		showTime: false,
		sort: 'asc'
	},
	favorites: {
		displayGroups: false
	},
	tags: {
		displayGroups: false
	}
};

export function useSettings() {
	const [settings, setSettings] = useState(() => {
		const stored = storage.get('settings');
		return {
			...defaultSettings,
			...stored,
			notches: {
				...defaultSettings.notches,
				...(stored?.notches || {})
			}
		};
	});

	useEffect(() => {
		storage.set('settings', settings);
	}, [settings]);

	return [settings, setSettings];
}